import { ReactElement } from 'react';
import { Navigate, Route, Routes as Switch } from 'react-router-dom';

import { getAnalyticsRoutes } from 'modules/analytics/getAnalyticsRoutes';
import { featureConfig } from 'modules/common';
import { dashboardRoutesConfig, getDashboardRoutes } from 'modules/dashboard';
import { getDeFiRoutes } from 'modules/defi';

import { RootRoute } from './RootRoute';

export function Routes(): ReactElement {
  return (
    <Switch>
      <Route element={<RootRoute />} path="/">
        {getDashboardRoutes()}

        {getDeFiRoutes()}

        {featureConfig.isAnalyticsEnabled && getAnalyticsRoutes()}

        <Route
          element={
            <Navigate to={dashboardRoutesConfig.dashboard.generatePath()} />
          }
          path="*"
        />
      </Route>
    </Switch>
  );
}
